var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCheckoutTotal = function SvgIconCheckoutTotal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.504,
    height: 35.659,
    viewBox: "0 0 18.504 35.659",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M385.925,308.869a3.432,3.432,0,0,0-.853-2.447,7.738,7.738,0,0,0-2.9-1.677,34.253,34.253,0,0,1-3.524-1.528,11.235,11.235,0,0,1-2.541-1.745,7.012,7.012,0,0,1-1.65-2.315,7.785,7.785,0,0,1-.59-3.169,7.031,7.031,0,0,1,2.025-5.193,8.543,8.543,0,0,1,5.381-2.362v-4.012h3v4.068a7.83,7.83,0,0,1,5.193,2.765,9.112,9.112,0,0,1,1.875,5.952h-5.418a5.169,5.169,0,0,0-.928-3.365,3.064,3.064,0,0,0-2.484-1.116,3.162,3.162,0,0,0-2.381.872,3.322,3.322,0,0,0-.844,2.409,3.167,3.167,0,0,0,.825,2.287,9.082,9.082,0,0,0,3.066,1.762,33.987,33.987,0,0,1,3.684,1.7,10.641,10.641,0,0,1,2.437,1.8,6.971,6.971,0,0,1,1.518,2.287,7.866,7.866,0,0,1,.525,2.991,7,7,0,0,1-1.987,5.174,8.715,8.715,0,0,1-5.475,2.343v3.731H380.9v-3.712a9.023,9.023,0,0,1-5.953-2.728,8.8,8.8,0,0,1-2.108-6.159h5.418a4.988,4.988,0,0,0,1.059,3.422,3.865,3.865,0,0,0,3.047,1.19,3.718,3.718,0,0,0,2.606-.872A3.025,3.025,0,0,0,385.925,308.869Z",
    transform: "translate(-372.839 -284.422)",
    fill: "#062d5a"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckoutTotal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_checkout_total.97f318cf.svg";
export { ForwardRef as ReactComponent };